import { a as d, s as k } from "./core-n6tkrASC.js";
function O(t, e = {}) {
  const n = e.style ?? "long", r = e.nullLabel ?? "—";
  if (t == null || t === "") return r;
  const a = t instanceof Date ? t.getTime() : new Date(t).getTime();
  if (Number.isNaN(a)) return r;
  const i = e.now ?? Date.now(), c = Math.max(0, Math.round((i - a) / 1e3));
  if (n === "compact") {
    if (c < 60) return "now";
    const g = Math.floor(c / 60);
    if (g < 60) return `${g}m`;
    const f = Math.floor(g / 60);
    if (f < 24) return `${f}h`;
    const m = Math.floor(f / 24);
    if (m < 7) return `${m}d`;
    if (m < 30) return `${Math.floor(m / 7)}w`;
    const v = Math.floor(m / 30);
    return v < 12 ? `${v}mo` : `${Math.floor(v / 12)}y`;
  }
  if (c < 60) return "just now";
  const s = Math.round(c / 60);
  if (s < 60) return `${s} min${s === 1 ? "" : "s"} ago`;
  const l = Math.round(s / 60);
  if (l < 24) return `${l} hour${l === 1 ? "" : "s"} ago`;
  const u = Math.round(l / 24);
  if (u < 30) return `${u} day${u === 1 ? "" : "s"} ago`;
  const o = Math.round(u / 30);
  if (o < 12) return `${o} month${o === 1 ? "" : "s"} ago`;
  const h = Math.round(o / 12);
  return `${h} year${h === 1 ? "" : "s"} ago`;
}
var T = {
  "+1": "👍",
  "-1": "👎",
  heart: "❤️",
  eyes: "👀",
  rocket: "🚀",
  tada: "🎉"
};
function L(t) {
  return T[t] ?? t;
}
function R(t) {
  if (!t) return "?";
  const e = t.trim();
  if (!e) return "?";
  const n = e.indexOf("@"), r = (n > 0 ? e.slice(0, n) : e).split(/[\s._-]+/).filter(Boolean);
  return r.length >= 2 ? (r[0].charAt(0) + r[r.length - 1].charAt(0)).toUpperCase() : (r[0]?.charAt(0) ?? "?").toUpperCase();
}
function U(t, e) {
  if (t) {
    const n = t.getClientRects();
    if (n.length > 0) return n[0];
    const r = t.getBoundingClientRect();
    if (r.width > 0 || r.height > 0) return r;
  }
  return e ? e.getBoundingClientRect() : null;
}
var A = "[data-pageloop], .pl-sidebar, .pl-toolbar, .pl-mini, .pl-tooltip, .pl-ctooltip, .pl-config-menu, .pl-toast-host, .pl-bubble-layer";
function V(t, e) {
  return !(e.width === 0 && e.height === 0 || t && typeof t.closest == "function" && t.closest(A));
}
function j(t) {
  let e = t;
  for (; e && e !== document.documentElement; ) {
    const n = window.getComputedStyle(e), r = n.overflowY, a = n.overflowX, i = (r === "auto" || r === "scroll") && e.scrollHeight > e.clientHeight, c = (a === "auto" || a === "scroll") && e.scrollWidth > e.clientWidth;
    if (i || c) return e;
    e = e.parentElement;
  }
  return document.documentElement;
}
function Y(t, e) {
  if (t && typeof CSS < "u" && "highlights" in CSS && typeof Highlight < "u") try {
    const n = new Highlight(t);
    CSS.highlights.set("pl-flash", n), setTimeout(() => CSS.highlights.delete("pl-flash"), 1500);
    return;
  } catch {
  }
  e instanceof HTMLElement && (e.classList.remove("pl-element-flash"), e.offsetWidth, e.classList.add("pl-element-flash"), setTimeout(() => e.classList.remove("pl-element-flash"), 1500));
}
function p(t) {
  return t.replace(/[&<>"']/g, (e) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[e]);
}
function D(t) {
  if (!t) return "";
  let e = p(t);
  return e = e.replace(/```([^\n`]*)\n([\s\S]*?)\n```/g, (n, r, a) => `<pre class="pl-md-pre"><code>${a}</code></pre>`), e = e.replace(/`([^`\n]+)`/g, '<code class="pl-md-code">$1</code>'), e = e.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>"), e = e.replace(/(^|[^*\w])\*([^*\n]+)\*/g, "$1<em>$2</em>"), e = e.replace(/\[([^\]\n]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener nofollow ugc">$1</a>'), e = e.replace(/(^|[\s(])(https?:\/\/[^\s<>"')]+)/g, '$1<a href="$2" target="_blank" rel="noopener nofollow ugc">$2</a>'), e = e.split(/\n{2,}/).map((n) => {
    const r = n.trim();
    return r ? r.startsWith("<pre") ? r : `<p>${r.replace(/\n/g, "<br>")}</p>` : "";
  }).filter(Boolean).join(""), e;
}
function K(t, e = "Click again to confirm · Esc to cancel") {
  if (t.dataset.confirming === "1")
    return delete t.dataset.confirming, t.classList.remove("pl-btn--confirming"), !0;
  t.dataset.confirming = "1", t.classList.add("pl-btn--confirming");
  const n = t.getAttribute("data-pl-tip") ?? "";
  t.setAttribute("data-pl-tip", e);
  const r = () => {
    t.isConnected && t.dataset.confirming === "1" && (delete t.dataset.confirming, t.classList.remove("pl-btn--confirming"), t.setAttribute("data-pl-tip", n));
  }, a = (i) => {
    i.key === "Escape" && (r(), document.removeEventListener("keydown", a));
  };
  return document.addEventListener("keydown", a), window.setTimeout(() => {
    document.removeEventListener("keydown", a), r();
  }, 3e3), !1;
}
function X(t) {
  if (!(t instanceof Element)) return !1;
  const e = t.tagName;
  if (e === "INPUT" || e === "TEXTAREA" || e === "SELECT" || t.isContentEditable) return !0;
  const n = t.getAttribute("contenteditable");
  return n === "" || n === "true" || n === "plaintext-only";
}
function G(t, e, n, r, a = {}) {
  const i = a.withPills ?? !0, c = a.withAdder ?? !0, s = /* @__PURE__ */ new Map();
  for (const o of n) {
    const h = s.get(o.kind) ?? {
      count: 0,
      mine: !1
    };
    h.count++, r && o.userId === r && (h.mine = !0), s.set(o.kind, h);
  }
  const l = i ? [...s.entries()].map(([o, h]) => {
    const g = h.mine ? " pl-reaction--mine" : "", f = L(o);
    return `<button class="pl-reaction${g}" data-reaction-kind="${p(o)}" data-pl-tip="${p(f)}"><span>${p(f)}</span><span class="pl-reaction__count">${h.count}</span></button>`;
  }).join("") : "", u = c && r ? `<button class="pl-reaction-add" data-action="add-reaction" data-pl-tip="Add reaction">${p(a.adderLabel ?? "+ react")}</button>` : "";
  return !l && !u ? "" : `<div class="pl-reactions${a.extraClass ? ` ${a.extraClass}` : ""}" data-target-kind="${t}" data-target-id="${p(e)}">${l}${u}</div>`;
}
function J(t) {
  const e = '<span class="pl-comment__edit-actions"><button class="pl-btn pl-btn--mini" data-edit="cancel" type="button">Cancel</button><button class="pl-btn pl-btn--mini pl-btn--primary" data-edit="save" type="button">Save</button></span>';
  t.bodyEl.innerHTML = `<textarea class="pl-comment__edit-ta">${p(t.original)}</textarea>`;
  let n;
  t.layout === "inline" && t.metaEl ? (t.metaEl.innerHTML = (t.metaPrefixHtml ?? "") + e, n = t.metaEl) : (t.bodyEl.insertAdjacentHTML("beforeend", e), n = t.bodyEl);
  const r = t.bodyEl.querySelector("textarea"), a = n.querySelector('[data-edit="save"]'), i = n.querySelector('[data-edit="cancel"]'), c = t.layout === "inline" ? 44 : 84, s = t.layout === "inline" ? 200 : 320, l = () => {
    r.style.height = "auto", r.style.height = `${Math.min(s, Math.max(c, r.scrollHeight))}px`;
  };
  r.focus(), r.selectionStart = r.selectionEnd = r.value.length, l(), r.addEventListener("input", l);
  const u = async () => {
    const o = r.value.trim();
    if (!o || o === t.original) {
      t.onCancel();
      return;
    }
    a.disabled = !0, a.textContent = "Saving…";
    try {
      await t.onSave(o);
    } finally {
      a.disabled = !1, a.textContent = "Save";
    }
  };
  r.addEventListener("keydown", (o) => {
    (o.ctrlKey || o.metaKey) && o.key === "Enter" && (o.preventDefault(), o.stopPropagation(), u());
  }), i.addEventListener("click", (o) => {
    o.stopPropagation(), t.onCancel();
  }), a.addEventListener("click", (o) => {
    o.stopPropagation(), u();
  });
}
function S(t, e, n, r, a = {}) {
  t.emit("toast:show", {
    kind: "error",
    message: n
  }), t.emit("pl-error", {
    operation: e,
    code: a.code ?? "unknown",
    message: n,
    cause: r,
    extra: a.extra
  });
}
async function W(t, e) {
  try {
    const { token: n } = await t.api.call("pages.createShareToken", {
      pageId: e.pageId,
      permission: "task"
    }), r = t.api.getEndpoint().replace(/\/+$/, ""), a = new URLSearchParams({ pageId: e.pageId });
    e.commentId ? a.set("commentId", e.commentId) : a.set("taskStatus", "unresolved"), a.set("pl-share", n);
    const i = `${r}/api/v1/comments?${a.toString()}`;
    await navigator.clipboard.writeText(i), t.bus.emit("toast:show", {
      kind: "success",
      message: e.commentId ? "Agent link copied — this task" : "Agent link copied — open tasks"
    });
  } catch (n) {
    S(t.bus, "agent-link.copy", "Couldn't create the agent link.", n, { extra: { ...e } });
  }
}
async function q(t, e) {
  try {
    const { token: n } = await t.api.call("pages.createShareToken", {
      pageId: e.pageId,
      permission: "task"
    }), r = t.api.getEndpoint().replace(/\/+$/, ""), a = e.kind === "prompt" ? `${r}/api/v1/comments/prompt?${new URLSearchParams({
      pageId: e.pageId,
      "pl-share": n
    }).toString()}` : `${r}/api/v1/comments?${new URLSearchParams({
      pageId: e.pageId,
      taskStatus: "unresolved",
      agent: "1",
      "pl-share": n
    }).toString()}`;
    if (e.mode === "link") {
      await navigator.clipboard.writeText(a), t.bus.emit("toast:show", {
        kind: "success",
        message: e.kind === "prompt" ? "Prompt link copied" : "JSON link copied"
      });
      return;
    }
    const i = await fetch(a, { headers: { accept: "*/*" } });
    if (!i.ok) throw new Error(`HTTP ${i.status}`);
    const c = await i.text(), s = Number(i.headers.get("x-pageloop-task-count") ?? "NaN");
    if (s === 0) {
      t.bus.emit("toast:show", {
        kind: "info",
        message: "No open tasks on this page."
      });
      return;
    }
    await navigator.clipboard.writeText(c);
    const l = e.kind === "prompt" ? "prompt" : "JSON", u = Number.isNaN(s) ? "" : `${s} task${s === 1 ? "" : "s"} as `;
    t.bus.emit("toast:show", {
      kind: "success",
      message: `Copied ${u}${l}`
    });
  } catch (n) {
    S(t.bus, "agent-link.copy", "Couldn't build the agent resource.", n, { extra: { ...e } });
  }
}
async function F(t, e) {
  try {
    const n = `${t.api.getEndpoint().replace(/\/+$/, "")}/api/v1/projects/tasks/prompt?${new URLSearchParams({ projectId: e.projectId }).toString()}`, r = t.api.getToken(), a = await fetch(n, { headers: {
      accept: "*/*",
      ...r ? { authorization: `Bearer ${r}` } : {}
    } });
    if (!a.ok) throw new Error(`HTTP ${a.status}`);
    const i = await a.text(), c = Number(a.headers.get("x-pageloop-task-count") ?? "0"), s = Number(a.headers.get("x-pageloop-page-count") ?? "0");
    if (c === 0) {
      t.bus.emit("toast:show", {
        kind: "info",
        message: "No open tasks in this project yet."
      });
      return;
    }
    await navigator.clipboard.writeText(i), t.bus.emit("toast:show", {
      kind: "success",
      message: `Copied ${c} task${c === 1 ? "" : "s"} across ${s} page${s === 1 ? "" : "s"}`
    });
  } catch (n) {
    S(t.bus, "agent-link.copy-all", "Couldn't build the all-pages prompt.", n, { extra: { ...e } });
  }
}
var M = "pl_settings_v2", $ = "pl_settings_v1", Z = {
  1: "X-Small",
  2: "Small",
  3: "Medium",
  4: "Large",
  5: "X-Large"
}, y = {
  showReplyCountInBubbles: !1,
  showComments: !0,
  showTasks: !0,
  commentSpacing: "none",
  bubbleSize: 3,
  textSize: 3
}, Q = {
  none: 0,
  minimal: 10,
  relaxed: 20,
  spacious: 30
}, w = "pl_sidebar_mode_v1";
function tt() {
  const t = d.getItem(w);
  return t === "flyout" || t === "in-page" ? t : null;
}
function et(t) {
  t == null ? d.removeItem(w) : d.setItem(w, t);
}
var _ = "pl_sidebar_open_v1";
function nt() {
  const t = d.getItem(_);
  return t === "true" ? !0 : t === "false" ? !1 : null;
}
function rt(t) {
  d.setItem(_, t ? "true" : "false");
}
var I = "pl_chat_minimized_v1";
function at() {
  const t = d.getItem(I);
  return t === "true" ? !0 : t === "false" ? !1 : null;
}
function ot(t) {
  d.setItem(I, t ? "true" : "false");
}
var it = {
  1: 16,
  2: 20,
  3: 26,
  4: 39,
  5: 52
}, st = {
  1: 7.5,
  2: 9,
  3: 11.5,
  4: 17.25,
  5: 23
}, ct = {
  1: 0.8,
  2: 0.9,
  3: 1,
  4: 1.15,
  5: 1.3
};
function H(t) {
  const e = Math.round(t);
  return e < 1 ? 1 : e > 5 ? 5 : e;
}
function x(t) {
  const e = typeof t == "number" ? t : 3;
  return e === 1 ? 3 : e === 2 ? 4 : e === 3 ? 5 : H(e);
}
var lt = class {
  constructor() {
    k(this, "state", void 0), k(this, "listeners", /* @__PURE__ */ new Set());
    const t = d.getItem(M);
    if (t) {
      try {
        this.state = {
          ...y,
          ...JSON.parse(t)
        };
      } catch {
        this.state = { ...y };
      }
      return;
    }
    const e = d.getItem($);
    if (e) try {
      const n = JSON.parse(e);
      this.state = {
        ...y,
        ...n,
        bubbleSize: x(n.bubbleSize),
        textSize: x(n.textSize)
      }, d.setItem(M, JSON.stringify(this.state)), d.removeItem($);
      return;
    } catch {
    }
    this.state = { ...y };
  }
  get() {
    return this.state;
  }
  update(t) {
    this.state = {
      ...this.state,
      ...t
    }, d.setItem(M, JSON.stringify(this.state));
    for (const e of this.listeners) e(this.state);
  }
  subscribe(t) {
    return this.listeners.add(t), () => {
      this.listeners.delete(t);
    };
  }
}, b = 'viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="pl-icon" aria-hidden="true"', N = {
  settings: '<path d="M14 3.5H10M7 3.5H2M14 8H8.5M5.5 8H2M14 12.5H11.5M8.5 12.5H2"/><path d="M8.5 5V2M6.5 9.5V6.5M10 14v-3"/>',
  close: '<path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/>',
  pages: '<rect x="3.5" y="2" width="9" height="12" rx="1.3"/><path d="M6 5.5h4M6 8h4M6 10.5h2.5"/>',
  trash: '<path d="M2.5 4h11M5.5 4V2.5h5V4M6 7v5M10 7v5M3.5 4l.7 9.5a1 1 0 0 0 1 0.95h5.6a1 1 0 0 0 1-0.95L12.5 4"/>',
  edit: '<path d="M11.5 2l2.5 2.5L6 12.5l-3 1 1-3 7.5-8.5z"/>',
  check: '<path d="M3 8.5l3 3 7-7"/>',
  reopen: '<path d="M13.5 8a5.5 5.5 0 1 1-1.7-4"/><path d="M14 2v3.5h-3.5"/>',
  "chevron-down": '<path d="M3.5 6l4.5 4 4.5-4"/>',
  "chevron-right": '<path d="M6 3.5l4 4.5-4 4.5"/>',
  "expand-out": '<path d="M10 2h4v4M14 2L9.5 6.5M6 14H2v-4M2 14l4.5-4.5"/>',
  "external-link": '<path d="M7 3.5H4A1 1 0 0 0 3 4.5V12a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V9"/><path d="M9.5 3H13v3.5"/><path d="M13 3L7.5 8.5"/>',
  plus: '<path d="M8 3v10M3 8h10"/>',
  minus: '<path d="M3 8h10"/>',
  link: '<path d="M6.5 9.5l3-3"/><path d="M7 4.5l.8-.8a2.6 2.6 0 0 1 3.7 3.7l-.8.8"/><path d="M9 11.5l-.8.8a2.6 2.6 0 0 1-3.7-3.7l.8-.8"/>',
  copy: '<rect x="6" y="6" width="8" height="8" rx="1.5"/><path d="M3.5 10H3A1.5 1.5 0 0 1 1.5 8.5V3A1.5 1.5 0 0 1 3 1.5h5.5A1.5 1.5 0 0 1 10 3v.5"/>',
  "chat-bubble": '<path d="M3 4a1.5 1.5 0 0 1 1.5-1.5h7A1.5 1.5 0 0 1 13 4v5a1.5 1.5 0 0 1-1.5 1.5H7l-3 2.5V10.5H4.5A1.5 1.5 0 0 1 3 9V4z"/>',
  messages: '<path d="M3 4a1.5 1.5 0 0 1 1.5-1.5h7A1.5 1.5 0 0 1 13 4v5a1.5 1.5 0 0 1-1.5 1.5H7l-3 2.5V10.5H4.5A1.5 1.5 0 0 1 3 9V4z"/><circle cx="6" cy="6.25" r="0.7" fill="currentColor" stroke="none"/><circle cx="8" cy="6.25" r="0.7" fill="currentColor" stroke="none"/><circle cx="10" cy="6.25" r="0.7" fill="currentColor" stroke="none"/>',
  eye: '<path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/>',
  target: '<circle cx="8" cy="8" r="5.5"/><path d="M8 1.5v3M8 11.5v3M1.5 8h3M11.5 8h3"/><circle cx="8" cy="8" r="1"/>',
  user: '<circle cx="8" cy="5.5" r="2.5"/><path d="M3 14a5 5 0 0 1 10 0"/>'
};
function ut(t, e) {
  const n = N[t];
  return n ? `<svg ${e ? b.replace('class="pl-icon"', `class="pl-icon pl-icon--${e}"`) : b}>${n}</svg>` : (typeof console < "u" && console.warn(`[pageloop] unknown icon: ${t}`), `<svg ${b}></svg>`);
}
var C = 'viewBox="0 0 40 40" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="pl-empty-illu" aria-hidden="true"', P = {
  "no-comments": '<path d="M7 11a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H17l-6 5v-5h-1a3 3 0 0 1-3-3V11z"/><path d="M14 14.5h12M14 18.5h7" opacity="0.6"/><path d="M30 6.5l1 2.2 2.2 1-2.2 1-1 2.2-1-2.2-2.2-1 2.2-1z" opacity="0.7"/>',
  "no-page": '<path d="M11 5h12l6 6v24H11z"/><path d="M23 5v6h6" opacity="0.6"/><path d="M20 16c-2.8 0-5 2.1-5 4.8 0 3.4 5 7.2 5 7.2s5-3.8 5-7.2c0-2.7-2.2-4.8-5-4.8z"/><circle cx="20" cy="20.6" r="1.4" fill="currentColor" opacity="0.8"/>'
};
function dt(t) {
  const e = P[t];
  return e ? `<svg ${C}>${e}</svg>` : `<svg ${C}></svg>`;
}
var E = 'viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" class="pl-icon" aria-hidden="true"', z = {
  target: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4" opacity="0.55"/><circle cx="12" cy="12" r="1.4" fill="currentColor"/><path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3"/>',
  eye: '<path d="M2.5 12s3.4-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.4 6.5-9.5 6.5S2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/><circle cx="13.2" cy="11" r="0.9" fill="currentColor"/>',
  "chat-bubble": '<path d="M5 4h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6.5l-4.4 3.4a0.4 0.4 0 0 1-0.6-0.32V17H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><circle cx="8.5" cy="10.5" r="0.95" fill="currentColor" opacity="0.7"/><circle cx="12"  cy="10.5" r="0.95" fill="currentColor" opacity="0.7"/><circle cx="15.5" cy="10.5" r="0.95" fill="currentColor" opacity="0.7"/>',
  settings: '<path d="M3.5 6h17M3.5 12h17M3.5 18h17" opacity="0.55"/><circle cx="9"   cy="6"  r="2.25" fill="currentColor" fill-opacity="0.14"/><circle cx="9"   cy="6"  r="2.25"/><circle cx="15"  cy="12" r="2.25" fill="currentColor" fill-opacity="0.14"/><circle cx="15"  cy="12" r="2.25"/><circle cx="7.5" cy="18" r="2.25" fill="currentColor" fill-opacity="0.14"/><circle cx="7.5" cy="18" r="2.25"/>',
  user: '<circle cx="12" cy="8.5" r="3.5" fill="currentColor" fill-opacity="0.14"/><circle cx="12" cy="8.5" r="3.5"/><path d="M4.5 20c0-3.8 3.4-6.5 7.5-6.5s7.5 2.7 7.5 6.5" fill="currentColor" fill-opacity="0.14"/><path d="M4.5 20c0-3.8 3.4-6.5 7.5-6.5s7.5 2.7 7.5 6.5"/>',
  "user-filled": '<circle cx="12" cy="8.5" r="3.5" fill="currentColor"/><path d="M4.5 20c0-3.8 3.4-6.5 7.5-6.5s7.5 2.7 7.5 6.5" fill="currentColor"/>',
  close: '<path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/>',
  "external-link": '<path d="M11 5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-5"/><path d="M14 4h6v6"/><path d="M20 4L11 13"/>'
};
function ht(t) {
  const e = z[t];
  return e ? `<svg ${E}>${e}</svg>` : (typeof console < "u" && console.warn(`[pageloop] unknown mini icon: ${t}`), `<svg ${E}></svg>`);
}
export {
  K as A,
  R as C,
  G as D,
  J as E,
  O as M,
  D as O,
  Y as S,
  X as T,
  W as _,
  it as a,
  j as b,
  lt as c,
  tt as d,
  nt as f,
  q as g,
  rt as h,
  st as i,
  L as j,
  S as k,
  ct as l,
  et as m,
  ut as n,
  Z as o,
  ot as p,
  ht as r,
  Q as s,
  dt as t,
  at as u,
  F as v,
  V as w,
  U as x,
  p as y
};
